import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { Loader } from "./utils/pageLoader";
import { InjectionDataProvider } from "./contexts/InjectionDataContext";
import HyPetMachineView from "./HyPET/subpages/HyPetMachineView";
import HyPetTimeSeriesView from "./HyPET/subpages/HyPetTimeSeriesView";
import HyCAPMachineView from "./HyCAP/subpages/HyCAPMachineView";
import HyCAPTimeSeriesView from "./HyCAP/subpages/HyCAPTimeSeriesView";
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
// Define dark and light themes
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    // Customize further as needed
  },
});

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    // Customize further as needed
  },
});

const InjectionMouldingPage = Loader(lazy(() => import("./InjectionCycle")));
const SilosPage = Loader(lazy(() => import("./Silos")));
const BlendersPage = Loader(lazy(() => import("./Blenders")));
const DryersPage = Loader(lazy(() => import("./Dryers")));
const DryersReportPage = Loader(lazy(() => import("./Dryers/subpages/report")));
const BlenderReportPage = Loader(
  lazy(() => import("./Blenders/subpages/report"))
);
const HyPETPage = Loader(lazy(() => import("./HyPET")));
const HyCAPPage = Loader(lazy(() => import("./HyCAP")));
const InjectionMoudlingTroubleshootingOG = Loader(
  lazy(() => import("./TroubleshootingModule/TroubleShootParent"))
);

const InjectionPdMRoutes: React.FC = () => {
  return (
    <InjectionDataProvider>
      <Routes>
        <Route path="/" element={<InjectionMouldingPage />} />
        <Route path="/silos" element={<SilosPage />} />
        <Route path="/blenders" element={<BlendersPage />} />
        <Route
          path="/blenders/reportview/:assetid"
          element={<BlenderReportPage />}
        />
        <Route path="/dryers/" element={<DryersPage />} />
        <Route
          path="/dryers/reportview/:assetid"
          element={<DryersReportPage />}
        />
        <Route path="/hypets" element={<HyPETPage />} />
        <Route
          path="/hypets/:hypet/machineview"
          element={<HyPetMachineView />}
        />
        <Route
          path="/hypets/:hypet/:hypetchild/machineview"
          element={<HyPetMachineView />}
        />
        <Route
          path="/hypets/:hypet/:hypetchild/:hypetsubchild/machineview"
          element={<HyPetMachineView />}
        />
        <Route
          path="/hypets/:hypet/:hypetchild/:hypetsubchild/:hypetsubsubchild/machineview"
          element={<HyPetMachineView />}
        />
        <Route
          path="/hypets/:hypet/:hypetchild/reportview"
          element={<HyPetTimeSeriesView />}
        />
        <Route
          path="/hypets/:hypet/:hypetchild/:hypetsubchild/reportview"
          element={<HyPetTimeSeriesView />}
        />
        <Route path="/hycaps" element={<HyCAPPage />} />
        <Route
          path="/hycaps/:hycap/machineview"
          element={<HyCAPMachineView />}
        />
        <Route
          path="/hycaps/:hycap/:hycapchild/machineview"
          element={<HyCAPMachineView />}
        />
        <Route
          path="/hycaps/:hycap/:hycapchild/:hycapsubchild/machineview"
          element={<HyCAPMachineView />}
        />
        <Route
          path="/hycaps/:hycap/:hycapchild/:hycapsubchild/:hycapsubsubchild/machineview"
          element={<HyCAPMachineView />}
        />
        <Route
          path="/hycaps/:hycap/:hycapchild/reportview"
          element={<HyCAPTimeSeriesView />}
        />
        <Route
          path="/hycaps/:hycap/:hycapchild/:hycapsubchild/reportview"
          element={<HyCAPTimeSeriesView />}
        />
        <Route
          path="/troubleshooting-module"
          element={<InjectionMoudlingTroubleshootingOG />}
        />
      </Routes>
    </InjectionDataProvider>
  );
};

export default InjectionPdMRoutes;
